export const delimiterMap: Record<string, string> = {
                '\\{': '{',
                '\\}': '}',
                '\\langle': '< ',
                '\\rangle': '> '
            };